module.exports = __webpack_public_path__ + "static/media/new-mobile-3.11fcf98a.png";